<ng-template #loadingTemplate>
    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
</ng-template>
<div style="display: flex">
    <p-dialog
        header="Insert new schedule?"
        [(visible)]="showDialog"
        [maximizable]="false"
        [closable]="false"
        [closeOnEscape]="false"
        [style]="{ width: '27vw', height: '27vh' }"
    >
        <label>
            Changing the scheduled end date will impact the start date of the subsequent schedule.
        </label>
        <label style="margin-top: 2em;">
            Do you want to insert a new schedule instead?
        </label>
        <ng-template #footer>
            <button
                type="button"
                pButton
                icon="pi pi-check"
                (click)="onSaveInvoiceSchedule('yes')"
                label="Yes"
                class="p-button-text"
            ></button>
            <button
                type="button"
                pButton
                (click)="onSaveInvoiceSchedule('no')"
                icon="pi pi-times"
                label="No"
                class="p-button-text"
            ></button>
        </ng-template>
    </p-dialog>
</div>
<!-- main content -->
<p-table stripedRows #dtInvoiceManagement
    [value]="items"
    dataKey="id"
    editMode="row"
    (onEditInit)="onEditInit($event)"
    (onRowEditSave)="onRowEditSave($event)"
    [(selection)]="selected"
    [customSort]="true"
    (onFilter)="onFilter($event)"
    (sortFunction)="onSort($event)"
    scrollHeight="flex"
    [scrollable]="true"
    selectionMode="single"
    (onRowSelect)="onRowSelect($event)"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item let-edit="editing">

        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Contract -->
            <th>
                Contract
                <p-sortIcon
                    pSortableColumn="ContractDesc"
                    field="ContractDesc"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Invoice Level -->
            <th>
                Invoice Level
                <p-sortIcon
                    pSortableColumn="InvoiceLevel"
                    field="InvoiceLevel"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Schedule Start Date -->
            <th>
                Start
                <p-sortIcon
                    pSortableColumn="ScheduledStartDate"
                    field="ScheduledStartDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Scheduled End Date -->
            <th>
                End
                <p-sortIcon
                    pSortableColumn="ScheduledEndDate"
                    field="ScheduledEndDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Invoice Date -->
            <th>
                Invoice Date
                <p-sortIcon
                    pSortableColumn="InvoiceDate"
                    field="InvoiceDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Invoice Amount -->
            <th>
                Contract Total
                <p-sortIcon
                    pSortableColumn="InvoiceAmount"
                    field="InvoiceAmount"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Sent To QB -->
            <th>
                Sent To QB
                <p-sortIcon
                    pSortableColumn="InvoiceSentToQB"
                    field="InvoiceSentToQB"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-item
        let-edit="editing"
        let-ri="rowIndex"
        let-rowData
    >
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === rowData?.id
            }"
        >
            <!-- Edit -->
            <td class="edit-cell">
                <!-- for a new row -->
                <button
                    title="Add"
                    *ngIf="item?.id === 'add' && !edit"
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-plus"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditInit(item)"
                ></button>
                <button
                    title="Edit"
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== 'add'
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(item)"
                    title="Edit"
                ></button>
                <button
                    title="Save"
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    title="Cancel"
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Contract -->
            <td class="disabled">
                {{ item.ContractDesc }}
            </td>
            <!-- Invoice Level -->
            <td class="disabled">
                {{ item.InvoiceLevel }}
            </td>
            <!-- Schedule Start Date -->
            <td class="disabled">
                {{
                    moment(item?.ScheduledStartDate).isValid()
                        ? moment(item?.ScheduledStartDate).format('MM/DD/YYYY')
                        : ''
                }}
            </td>
            <!-- Scheduled End Date -->
            <td>
                <p-cellEditor>
                    <ng-template
                        *ngIf="canEditScheduledEndDate(item)"
                        pTemplate="input"
                    >
                        <p-calendar
                            inputStyleClass="p-inputtext"
                            [(ngModel)]="item.ScheduledEndDate"
                            [ngModelOptions]="{ standalone: true }"
                            appendTo="body"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            yearRange="2000:2030"
                            [readonlyInput]="false"
                            dateFormat="mm/dd/yy"
                            [required]="true"
                        >
                        </p-calendar>
                    </ng-template>
                    <ng-template
                        *ngIf="!canEditScheduledEndDate(item)"
                        pTemplate="input"
                    >
                        {{
                            moment(item?.ScheduledEndDate).isValid()
                                ? moment(item?.ScheduledEndDate).format(
                                      'MM/DD/YYYY'
                                  )
                                : ''
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            moment(item?.ScheduledEndDate).isValid()
                                ? moment(item?.ScheduledEndDate).format(
                                      'MM/DD/YYYY'
                                  )
                                : ''
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Invoice Date -->
            <td class="disabled">
                {{
                    moment(item?.InvoiceDate).isValid()
                        ? moment(item?.InvoiceDate).format('MM/DD/YYYY')
                        : ''
                }}
            </td>
            <!-- Invoice Amount -->
            <td class="disabled currency">
                {{ item?.InvoiceAmount | currency }}
            </td>
            <!-- Sent To QB -->
            <td class="disabled">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-checkbox
                            binary="true"
                            [(ngModel)]="item.InvoiceSentToQB"
                            [ngModelOptions]="{ standalone: true }"
                        ></p-checkbox>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i
                            [ngClass]="{
                                pi: true,
                                'pi-check': item?.InvoiceSentToQB,
                                'pi-times': !item?.InvoiceSentToQB,
                                green: item?.InvoiceSentToQB,
                                red: !item?.InvoiceSentToQB
                            }"
                        ></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i
                            [ngClass]="{
                                pi: true,
                                'pi-check': item?.InvoiceSentToQB,
                                'pi-times': !item?.InvoiceSentToQB,
                                green: item?.InvoiceSentToQB,
                                red: !item?.InvoiceSentToQB
                            }"
                        ></i>
                    </ng-template>
                </p-cellEditor>
            </td>
        </tr>
    </ng-template>
</p-table>
